module.exports = __webpack_public_path__ + "static/img/teBuContent3.6eb59f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teBuContent3.png
// module id = 6JMZ
// module chunks = 2